module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dofBadge",
    staticClass: " weex-ct weex-div",
    class: [_vm.activeBoxPosClass, _vm.activeBoxClass],
    style: (_vm._px2rem(_vm.badgeStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(!_vm.dot) ? _c('p', {
    staticClass: " weex-el weex-text",
    class: ['text-desc', _vm.activeTextClass],
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.contentValue))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f2ac79e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f2ac79e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-badge/index.vue
// module id = 608
// module chunks = 0 1